module.exports = __webpack_public_path__ + "calendar.png?d7ef0f84f480950a78695c26acbc7d57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point-register/calendar.png
// module id = 993
// module chunks = 0